import React from 'react'
import { Link } from 'react-router-dom'
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'
import { IconUser, IconUserPlus } from '@tabler/icons-react'
import styled, { css } from 'styled-components'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import ContributorModal from '../../../../views/_templates/ContributorModal'
import ArcRequestModal from '../../../../views/_templates/ArcRequestModal'
import { Role } from '../../../../utility/types'
import { Avatar } from 'dsm-react-lib'
import { getUserInitials } from '../../../../utility/Utils'

const StyledAvatar = styled(Avatar)`
  min-width: 35px;
  min-height: 35px;
`

const UserDropdown = ({ onlyAvatar }) => {
  const { displayName, profilePictureBase64Encoded: imgUrl } = JSON.parse(
    localStorage.getItem('userInfoData')
  )

  const {
    jobFunction: { name }
  } = useSelector((state) => state.profileReducer.profile)

  const [contributorModal, setContributorModal] = useState(false)
  const [isArcRequestModalOpen, setIsArcRequestModalOpen] = useState(false)

  const { roles } = useSelector((state) => state.userContextReducer.userContext)
  const isContributor = roles?.includes(Role.Contributor)
  const isAdmin = roles?.includes(Role.Admin)

  const handleToggleArcRequestModal = () => {
    setIsArcRequestModalOpen((prevState) => !prevState)
    setContributorModal((prevState) => !prevState)
  }

  return onlyAvatar ? (
    <StyledAvatar
      content={imgUrl ? imgUrl : getUserInitials(displayName)}
      {...(imgUrl ? {} : { bgColor: 'light-secondary' })}
      size="35px"
    />
  ) : (
    <>
      <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
        <DropdownToggle
          href="/"
          tag="a"
          className="nav-link dropdown-user-link"
          onClick={(e) => e.preventDefault()}>
          <div className="user-nav d-sm-flex d-none">
            <span className="user-name font-weight-bold">
              {(displayName && displayName.split(',')[1]) || displayName}
            </span>
            <span className="user-status">{name}</span>
          </div>
          <Avatar
            content={imgUrl ? imgUrl : getUserInitials(displayName)}
            {...(imgUrl ? {} : { bgColor: 'light-secondary' })}
            size="45px"
          />
        </DropdownToggle>
        <DropdownMenu end className="w-auto">
          <DropdownItem tag={Link} to="/profile" data-testid="profileBtn" className="flex">
            <IconUser size={14} className="me-75" />
            <span className="align-middle">Profile</span>
          </DropdownItem>
          {!isAdmin && (
            <DropdownItem
              onClick={() => setContributorModal(!contributorModal)}
              data-testid="profileBtn"
              className="flex">
              <IconUserPlus size={14} className="mr-75" />
              <span className="align-middle">
                {isContributor ? 'Contributor' : 'Become a Contributor'}
              </span>
            </DropdownItem>
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
      {contributorModal && (
        <ContributorModal
          isOpen={contributorModal}
          toggle={() => setContributorModal(!contributorModal)}
          handleToggleArcRequestModal={handleToggleArcRequestModal}
          isContributor={isContributor}
        />
      )}
      {isArcRequestModalOpen && (
        <ArcRequestModal
          isOpen={isArcRequestModalOpen}
          toggle={() => setIsArcRequestModalOpen(false)}
          isContributorReq={true}
        />
      )}
    </>
  )
}

export default UserDropdown
